import React, {useEffect, useState} from 'react'
import LoadingOverlay from 'react-loading-overlay'
import {TablaUsuarios} from '../../components/TablaUsuarios/TablaUsuarios'
import {AdminAlert} from '../../components/AdminAlert/AdminAlert'
import {AdminTableSearch} from '../../components/AdminDataTable/AdminDataTable'
import axios from 'axios'
import {useAuth} from '../../modules/auth'

import './Distribuidores.css'
import '../Vendedores/Vendedores.css'
import {Modal} from 'react-bootstrap'
import {ModalDistribuidor} from '../../components/ModalDistribuidor/ModalDistribuidor'

function Distribuidores() {
  const API_URL = process.env.REACT_APP_API_URL
  const {currentUser} = useAuth()

  const [spinnerIsActive, setSpinnerIsActive] = useState(false)

  const [usuarios, setUsuarios] = useState([])
  const [vendedores, setVendedores] = useState([])
  const [listasPrecios, setListasPrecios] = useState([])

  const [usuarioDetalle, setUsuarioDetalle] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [modalMode, setModalMode] = useState('edit')
  const [message, setMessage] = useState(null)

  const [searchValue, setSearchValue] = useState('')

  const Usuarios = async () => {
    setSpinnerIsActive(true)
    try {
      const res = await axios.get(`${API_URL}/distribuidores`)
      setUsuarios(res.data)
    } catch (e) {
      console.error(e)
    } finally {
      setSpinnerIsActive(false)
    }
  }

  const getVendedores = () => {
    axios.get(API_URL + '/lista-vendedores').then((res) => {
      setVendedores(res.data)
    })
  }

  const getListasPrecios = () => {
    axios.get(API_URL + '/listas-precios').then((res) => setListasPrecios(res.data))
  }

  const mostrarUsuario = async (id) => {
    const res = await axios.get(`${API_URL}/distribuidores-detalle/${id}`)
    setUsuarioDetalle(res.data)
    setModalMode('edit')
    setShowModal(true)
  }

  const nuevoDistribuidor = () => {
    setUsuarioDetalle(null)
    setModalMode('create')
    setShowModal(true)
  }

  const actualizarUsuarioDetalle = async (id) => {
    const res = await axios.get(`${API_URL}/distribuidores-detalle/${id}`)
    setUsuarioDetalle(res.data)
    await Usuarios()
  }

  const distribuidorCreado = async () => {
    setShowModal(false)
    setUsuarioDetalle(null)
    await Usuarios()
    setMessage({type: 'success', text: 'Distribuidor creado correctamente.'})
  }

  useEffect(() => {
    Usuarios()
    getVendedores()
    getListasPrecios()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const filteredUsuarios = usuarios.filter((u) =>
    Object.values(u).join(' ').toLowerCase().includes(searchValue.toLowerCase())
  )

  return (
    <LoadingOverlay active={spinnerIsActive} spinner text='Cargando...'>
      <div className='sellers-page'>
        <AdminAlert message={message} onClose={setMessage} />
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          dialogClassName='modal-distribuidor-dialog'
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {modalMode === 'create' ? 'Nuevo distribuidor' : 'Detalle de Distribuidor'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {(modalMode === 'create' || usuarioDetalle) && (
              <ModalDistribuidor
                mode={modalMode}
                usuario={usuarioDetalle}
                vendedores={vendedores}
                listasPrecios={listasPrecios}
                onClose={() => setShowModal(false)}
                onUpdated={actualizarUsuarioDetalle}
                onCreated={distribuidorCreado}
              />
            )}
          </Modal.Body>
        </Modal>

        <div className='card card-custom shadow admin-list-card sellers-card'>
          <div className='card-header sellers-header'>
            <div>
              <h1>Distribuidores</h1>
              <p>
                Administra la información, condiciones comerciales y acceso de los distribuidores.
              </p>
            </div>
            {['Admin', 'Gerente Comercial'].includes(currentUser?.rol) && (
              <button
                type='button'
                className='btn btn-primary sellers-add'
                onClick={nuevoDistribuidor}
              >
                <i className='fas fa-plus'></i> Nuevo distribuidor
              </button>
            )}
          </div>
          <div className='card-body'>
            <AdminTableSearch
              value={searchValue}
              onChange={(event) => setSearchValue(event.target.value)}
              ariaLabel='Buscar distribuidores'
            />

            <TablaUsuarios usuarios={filteredUsuarios} mostrarUsuario={mostrarUsuario} />
          </div>
        </div>
      </div>
    </LoadingOverlay>
  )
}

export {Distribuidores}
